module.exports = __webpack_public_path__ + "img/workplan.8a8c54e.svg";